<template>
  <div class="profile-coupons">
    <h2 class="page-title">{{$t('profile.itemCoupons')}}</h2>
    <div class="text-center" v-if="!dataLoaded">
      <div class="loading-icon"></div>
    </div>
    <template v-if="dataLoaded">
      <div class="empty-state" v-if="!coupons.length">
        <p>{{$t('coupons.tipEmpty')}}</p>
        <router-link :to="{name: 'profile-invitation'}">
          <button class="btn primary small">{{$t('coupons.buttonLoadMore')}}</button>
        </router-link>
      </div>
      <div class="coupon-list" v-if="coupons.length">
        <coupon-item v-for="(coupon, index) in coupons"
                     :coupon="coupon" :key="index"></coupon-item>
        <p class="text-center" style="margin-top: 1.5rem;">
          <router-link :to="{name: 'profile-invitation'}">
            <button class="btn default small">{{$t('coupons.buttonLoadMore')}}</button>
          </router-link>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import api from 'src/api/'
import CouponItem from '../../components/layout/Coupon.vue'
import { isEmpty } from 'lodash'
export default {
  name: 'profile-coupons',
  components: { CouponItem },
  data () {
    return {
      dataLoaded: false,
      coupons: [],
      couponNo: ''
    }
  },
  created () {
    this.fetchCoupons()
  },
  methods: {
    fetchCoupons () {
      return api.fetchAllCoupon().then(data => {
        this.dataLoaded = true
        if (!data || data.errors) {
          this.$toast({
            message: this.$t('coupons.tipLoading'),
            position: 'bottom'
          })
          return
        }
        const items = data.map(item => {
          if (!isEmpty(item.accountCoupon)) {
            item.coupon.rest = item.accountCoupon.rest
            item.coupon.used = item.accountCoupon.used
          }
          return item.coupon
        })
        let coupons = items.filter(item => (item.scope !== 'group_buying' || item.rules.groupAvaliable) && Date.now() >= new Date(item.beginAt).getTime())
        const sortKeys = ['all', 'diarybook', 'photobook', 'calendar']
        const sortObj = coupons.reduce((sortMap, coupon) => {
          if (!sortMap[coupon.bookType]) {
            sortMap[coupon.bookType] = []
          }
          sortMap[coupon.bookType].push(coupon)
          return sortMap
        }, {})
        coupons = sortKeys.reduce((list, key) => {
          if (sortObj[key]) {
            list = list.concat(sortObj[key])
          }
          return list
        }, [])
        this.coupons = coupons
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.profile-coupons {
  max-width: 640px;
  margin: 0 auto;
  padding: 2rem 1rem;

  .page-title {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 1.5rem;
    color: #1f2937;
    text-align: left;
  }

  .empty-state {
    text-align: center;
    padding: 3rem 0;
    color: #9ca3af;

    p {
      margin-bottom: 1rem;
    }
  }

  .coupon-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
